const e = {
  undo: "Rückgängig machen",
  redo: "Wiederholen",
  confirm: "Bestätigen",
  clear: "Löschen",
  more: "Mehr",
  cancel: "Stornieren",
  update: "Aktualisierung"
}, n = {
  positiveText: "Bestätigen",
  negativeText: "Stornieren"
}, t = {
  placeholder: "Bitte auswählen",
  loading: "Laden"
}, a = {
  clear: "Löschen",
  now: "Jetzt",
  confirm: "Bestätigen",
  selectTime: "Zeit auswählen",
  selectDate: "Datum auswählen",
  datePlaceholder: "Datum auswählen",
  datetimePlaceholder: "Tag und Datum auswählen",
  monthPlaceholder: "Monat auswählen",
  yearPlaceholder: "Jahr auswählen",
  quarterPlaceholder: "Quartal auswählen",
  startDatePlaceholder: "Startdatum",
  endDatePlaceholder: "Enddatum",
  startDatetimePlaceholder: "Startdatum und -uhrzeit",
  endDatetimePlaceholder: "Enddatum und -zeit",
  startMonthPlaceholder: "Startmonat",
  endMonthPlaceholder: "Ende Monat",
  today: "Heute"
}, r = {
  checkTableAll: "Alle in der Tabelle auswählen",
  uncheckTableAll: "Alle Auswahl in der Tabelle aufheben",
  confirm: "Bestätigen",
  clear: "Löschen",
  apply: "Anwenden",
  filters: "Filter",
  sort: "Sortieren"
}, l = {
  sourceTitle: "Quelle",
  targetTitle: "Ziel"
}, i = {
  selectAll: "Alle auswählen",
  unselectAll: "Auswahl aufheben",
  clearAll: "Löschen"
}, o = {
  description: "Keine Info"
}, c = {
  placeholder: "Bitte auswählen"
}, s = {
  placeholder: "Zeit auswählen",
  positiveText: "OK",
  negativeText: "Stornieren",
  now: "Jetzt"
}, d = {
  goto: "Goto",
  selectionSuffix: "Seite",
  next: "Nächste",
  previous: "Vorherige"
}, u = {
  add: "Hinzufügen"
}, h = {
  loading: "Laden"
}, g = {
  placeholder: "Bitte eingeben"
}, m = {
  placeholder: "Bitte eingeben"
}, p = {
  create: "Erstellen"
}, f = {
  title: "Betreff-Editor",
  clearAllVars: "Alle Variablen löschen",
  clearSearch: "Suche zurücksetzen",
  filterCompName: "Filterkomponenten-Name",
  filterVarName: "Filtervariablenname",
  import: "Import",
  export: "Exportieren",
  restore: "Auf Standard zurücksetzen"
}, b = {
  tipPrevious: "VERGANGENHEIT Bild (←)",
  tipNext: "Nächstes Bild (→)",
  tipCounterclockwise: "Entfernt",
  tipClockwise: "Im Uhrzeigersinn",
  tipZoomOut: "Vergrößern",
  tipZoomIn: "Vergrößern",
  tipClose: "Schließen (Esc)",
  tipOriginalSize: "Auf Originalgröße zoomen"
}, S = {
  heading: "Sortieren und Filter",
  sortHeading: "Sortieren nach",
  newestFirst: "Neueste zuerst",
  oldestFirst: "Älteste zuerst",
  ascending: "Asc",
  descending: "Desc",
  apply: "Anwenden",
  clear: "Löschen",
  cancel: "Stornieren",
  filters: "Filter"
}, T = {
  noMatchingFound: "Keine übereinstimmenden Ergebnisse gefunden"
}, P = {
  margin: "Rand",
  padding: "Innenabstand",
  reset: "Zurücksetzen",
  errorMsg: "Der ausgegebene Wert ist ungültig."
}, k = {
  brandColors: "Markenfarben",
  noBrandColors: "Du hast noch keine Markenfarben hinzugefügt.",
  getStarted: "Erste Schritte",
  add: "Hinzufügen",
  default: "Standard"
}, w = {
  addColor: "Neue Farbe hinzufügen",
  editColor: "Farbe bearbeiten",
  add: "Hinzufügen",
  noData: "Sie haben noch keine Farben hinzugefügt.",
  invalidCode: "Ungültiger Farbcode",
  defaultColor: "Standardfarben"
}, z = {
  global: e,
  Popconfirm: n,
  Cascader: t,
  DatePicker: a,
  DataTable: r,
  LegacyTransfer: l,
  Transfer: i,
  Empty: o,
  Select: c,
  TimePicker: s,
  Pagination: d,
  DynamicTags: u,
  Log: h,
  Input: g,
  InputNumber: m,
  DynamicInput: p,
  ThemeEditor: f,
  Image: b,
  SortFilter: S,
  IconPicker: T,
  Spacing: P,
  BrandColorPicker: k,
  BrandBoard: w
};
export {
  w as BrandBoard,
  k as BrandColorPicker,
  t as Cascader,
  r as DataTable,
  a as DatePicker,
  p as DynamicInput,
  u as DynamicTags,
  o as Empty,
  T as IconPicker,
  b as Image,
  g as Input,
  m as InputNumber,
  l as LegacyTransfer,
  h as Log,
  d as Pagination,
  n as Popconfirm,
  c as Select,
  S as SortFilter,
  P as Spacing,
  f as ThemeEditor,
  s as TimePicker,
  i as Transfer,
  z as default,
  e as global
};
